import React from 'react';
import './Skeleton.css';

const Skeleton = ({ 
  width, 
  height, 
  variant = 'rectangular',
  animation = 'pulse',
  className = '',
  ...props 
}) => {
  const style = {
    width: width || '100%',
    height: height || '1rem',
    ...props.style
  };

  return (
    <div
      className={`skeleton skeleton-${variant} skeleton-${animation} ${className}`}
      style={style}
      aria-hidden="true"
      {...props}
    />
  );
};

// Predefined skeleton components
export const SkeletonText = ({ lines = 3, ...props }) => (
  <div className="skeleton-text-group">
    {Array.from({ length: lines }).map((_, index) => (
      <Skeleton
        key={index}
        height="1rem"
        width={index === lines - 1 ? '60%' : '100%'}
        variant="rectangular"
        {...props}
      />
    ))}
  </div>
);

export const SkeletonCard = ({ ...props }) => (
  <div className="skeleton-card" {...props}>
    <Skeleton variant="rectangular" height="200px" />
    <div className="skeleton-card-content">
      <Skeleton height="1.5rem" width="80%" />
      <SkeletonText lines={3} />
    </div>
  </div>
);

export const SkeletonAvatar = ({ size = 40, ...props }) => (
  <Skeleton
    variant="circular"
    width={size}
    height={size}
    {...props}
  />
);

export default Skeleton;
